<!--

    SELECAO DO APLICATIVO E VISUALIZAÇÃO DOS PLANOS PARA CRIAÇÃO DA CONTA OU PARA PAGAMENTO DA CONTA



FALTA:
- tratar botoes quando for isEndTrial

-->

<template>

  <div class="registro">
    <header class="shared-header">
      <div class="col-md-12 col-12 text-center">
        <a class="valign" href="#">
          <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/logo-nb.png">
        </a>
      </div>
    </header>
    <transition name="fade" mode="out-in">
      <div class="container" v-if="selecionaApp" style="margin-bottom: 100px">

        <div v-if="isEndTrial">
          <div class="activation text-center mb-2">
            <h3>Seu período de testes expirou!</h3>
          </div>
          <div class="activation text-center mb-2">
            <h3>Selecione agora um plano para continuar a utilizar o Nota Brasil</h3>
          </div>
        </div>

        <div v-if="!isEndTrial && isPagamento">
          <div class="activation text-center mb-2">
            <h3>Selecione agora um plano para continuar a utilizar o Nota Brasil</h3>
          </div>
        </div>

        <div v-if="!isEndTrial && !isPagamento">
          <div class="title text-center">
            <div>Aplicativos Disponíveis</div>
          </div>
          <div class="app-info text-center mb-2">
            <h5>Selecione um dos aplicativos e teste grátis por 15 dias</h5>
          </div>
        </div>




        <div class="row activation justify-content-center">
          <!-- <div class="col-md-2">
                            <h5 class="mt-5">Selecione um dos aplicativos e <strong> teste grátis por 15 dias </strong></h5>
                        </div> -->
          <div class="col-md-4" v-if="showForcaVendas">
            <div class="app w-100 h-100" :class="{ 'active': appSelected == 'FV' }" @click="handleSelecionaApp('FV')">
              <div class="title"> Força de Vendas </div>
              <div class="app-info w-100 text-center">
                <h5> Aplicativo para potencializar as vendas de Industrias, Atacadistas e Representantes </h5>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="app w-100 h-100" :class="{ 'active': appSelected == 'LOJA' }"
              @click="handleSelecionaApp('LOJA')">
              <div class="title"> Loja Virtual </div>
              <div class="app-info w-100 text-center">
                <h5> Loja virtual para pequenos comércios e vendedores autônomos que queiram divulgar seus produtos nas
                  redes sociais e organizar as vendas de forma on-line</h5>
              </div>
            </div>
          </div>
          <div class="col-md-4" v-if="showNFe">
            <div class="app w-100 h-100" :class="{ 'active': appSelected == 'NFE' }" @click="handleSelecionaApp('NFE')">
              <div class="title"> Emissor de NF-e </div>
              <div class="app-info w-100 text-center">
                <h5> Aplicativo para emissão de NF-e de produtos e controle de pedidos com automação de regras de
                  impostos definidas pelo seu contador</h5>
              </div>
            </div>
          </div>
          <div class="col-md-4" v-if="false">
            <div class="app w-100 h-100" :class="{ 'active': appSelected == 'VAREJO' }"
              @click="handleSelecionaApp('VAREJO')">
              <div class="title"> Varejo On-Line </div>
              <div class="app-info w-100 text-center">
                <h5> Aplicativo de frente de caixa on-line </h5>
              </div>
            </div>
          </div>
        </div>




        <!-- PLANOS FORÇA DE VENDAS -->

        <div id="FV" v-if="appSelected == 'FV'">
          <div class="row text-center">
            <div class="w-100 title"> Planos Disponíveis </div>
          </div>

          <!-- <div class="app-info w-100 text-center">
                        <h5> Aplicativo para potencializar as vendas de Industrias, Atacadistas e Representantes </h5>
                    </div> -->

          <div class="activation">
            <div class="row">
              <div class="col-md-4 col-12 justify-content-center" v-for="(plano, index) in planoFV" :key="index">
                <div class="app h-100">
                  <div class="text-center">
                    <div class="justify-content-center title"> {{ plano.nome }} </div>
                    <div class="row price-info align-items-center text-center">
                      <span class="w-100 text-price"> Consulte </span>
                      <!-- <span class="w-100 text-price">
                                                R$
                                                <span class="price">{{ plano.valor | formatValue(2) }} </span>
                                            </span>
                                            <span class="w-100 text-price"> por mês </span> -->
                    </div>
                    <div class="info">
                      <p v-for="(descricao, index) in plano.descricao" :key="index"> {{ descricao }} </p>
                      <!-- <p v-if="plano.valor_adicional"> Usuário adicional: R$ {{ plano.valor_adicional | formatValue(2) }}/mês </p> -->
                    </div>
                  </div>
                  <div class="row justify-content-center w-100">
                    <button v-if="!isPagamento" type="button" class="app-button w-50"
                      @click="handleTestar(plano.app, plano.plano)"> Testar </button>
                    <button v-if="isPagamento" type="button" class="app-button w-50"
                      @click="handleAssinar(plano.app, plano.plano)"> Assinar </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row text-center">
              <div class="w-100 title"> Versões e Recursos </div>
            </div>
            <div class="recursos-container w-100 mt-5">
              <table class="w-100">
                <thead>
                  <tr>
                    <th>
                      <p class="title text-center">Descrição</p>
                    </th>
                    <th class="text-center">
                      <p class="title text-center"><strong>Básico</strong></p>
                    </th>
                    <th class="text-center">
                      <p class="title text-center"><strong>Intermediário</strong></p>
                    </th>
                    <th class="text-center">
                      <p class="title text-center"><strong>Completo</strong></p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(recurso, index) in recursos_fv" :key="index">
                    <td>
                      {{ recurso.text }}
                      <span v-if="recurso.novo" class="badge badge-red ml-2"> NOVO </span>
                    </td>
                    <td class="text-center">
                      <i v-if="recurso.plano1" class="fa fa-check" style="color:green; font-size: 25px;"
                        aria-hidden="true"></i>
                    </td>
                    <td class="text-center">
                      <i v-if="recurso.plano2" class="fa fa-check" style="color:green; font-size: 25px;"
                        aria-hidden="true"></i>
                    </td>
                    <td class="text-center">
                      <i v-if="recurso.plano3" class="fa fa-check" style="color:green; font-size: 25px;"
                        aria-hidden="true"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>

        </div>






        <div id="NFE" v-if="appSelected == 'NFE'">
          <div class="row text-center">
            <div class="w-100 title"> Planos Disponíveis </div>
          </div>
          <!-- <div class="app-info w-100 text-center">
                        <h5> Aplicativo para emissão de NF-e de produtos e controle de pedidos com automação de regras de impostos definidas pelo seu contador</h5>
                    </div> -->

          <div class="activation">
            <div class="row">
              <div class="col-md-4 col-12 justify-content-center" v-for="(plano, index) in planoNFe" :key="index">
                <div class="app h-100">
                  <div class="text-center">
                    <div class="justify-content-center title"> {{ plano.nome }} </div>
                    <div class="row price-info align-items-center text-center">
                      <span class="w-100 text-price">
                        R$
                        <span class="price">{{ plano.valor | formatValue(2) }} </span>
                      </span>
                      <span class="w-100 text-price"> por mês/CNPJ </span>
                    </div>
                    <div class="info">
                      <p v-for="(descricao, index) in plano.descricao" :key="index"> {{ descricao }} </p>
                    </div>
                  </div>
                  <div class="row justify-content-center w-100">
                    <button v-if="!isPagamento" type="button" class="app-button w-50"
                      @click="handleTestar(plano.app, plano.plano)"> Testar </button>
                    <button v-if="isPagamento" type="button" class="app-button w-50"
                      @click="handleAssinar(plano.app, plano.plano)"> Assinar </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>



        <div id="LOJA" v-if="appSelected == 'LOJA'">
          <div class="row text-center">
            <div class="w-100 title"> Loja Virtual </div>
          </div>
          <div class="app-info w-100 text-center">
            <h5> Loja virtual </h5>
          </div>

          <div class="activation">
            <div class="row">
              <div class="col-md-4 col-12 m-auto" v-for="(plano, index) in planoLoja" :key="index">
                <div class="app h-100">
                  <div class="text-center">
                    <div class="justify-content-center title"> {{ plano.nome }} </div>
                    <!-- <span class="badge badge-red"> Disponível em Janeiro/2020 </span> -->

                    <div class="row price-info align-items-center text-center">
                      <span class="w-100 text-price">
                        R$
                        <span class="price">{{ plano.valor | formatValue(2) }} </span>
                      </span>
                      <span class="w-100 text-price"> mensal/estabelecimento </span>
                    </div>
                    <div class="info">
                      <p v-for="(descricao, index) in plano.descricao" :key="index"> {{ descricao }} </p>
                    </div>
                  </div>
                  <div class="row justify-content-center w-100">
                    <button v-if="!isPagamento" type="button" class="app-button w-50"
                      @click="handleTestar(plano.app, plano.plano)"> Testar </button>
                    <button v-if="isPagamento" type="button" class="app-button w-50"
                      @click="handleAssinar(plano.app, plano.plano)"> Assinar </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>



        <div id="VAREJO" v-if="appSelected == 'VAREJO'">
          <div class="row text-center">
            <div class="w-100 title"> Varejo On-Line </div>
          </div>
          <div class="app-info w-100 text-center">
            <h5> Aplicativo de frente de caixa on-line </h5>
          </div>

          <div class="activation">
            <div class="row">
              <div class="col-md-4 col-12 justify-content-center" v-for="(plano, index) in planoVarejo" :key="index">
                <div class="app h-100">
                  <div class="text-center">
                    <div class="justify-content-center title"> {{ plano.nome }} </div>
                    <span class="badge badge-red"> Disponível em Janeiro/2020 </span>

                    <div class="row price-info align-items-center text-center">
                      <span class="w-100 text-price">
                        R$
                        <span class="price">{{ plano.valor | formatValue(2) }} </span>
                      </span>
                      <span class="w-100 text-price"> por mês/CNPJ </span>
                    </div>
                    <div class="info">
                      <p v-for="(descricao, index) in plano.descricao" :key="index"> {{ descricao }} </p>
                    </div>
                  </div>
                  <div class="row justify-content-center w-100">
                    <!-- <button type="button" class="app-button w-50" @click="handleTestar(plano.app, plano.plano)"> Testar </button> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>






        <div class="activation row justify-content-center text-center">
          <h3> Em caso de dúvidas, entre em contato com nosso atendimento via chat ou por telefone </h3>
          <h5> Nossos planos incluem suporte via CHAT ou telefone de segunda à sexta das 08:30 às 17:30 </h5>
        </div>


        <div class="box-clientes">

          <div class="row text-center p-5">
            <div class="title">
              Junte-se a mais de 1.200 clientes que já utilizam nossas ferramentas
            </div>
          </div>

          <div class="row text-center">
            <!-- <h3> Em caso de dúvidas, entre em contato com nosso atendimento via chat ou por telefone </h3> -->
          </div>


        </div>



      </div>
    </transition>

    <transition name="fade" mode="out-in">
      <div v-if="sucesso">
        <div class="activation text-center">
          <h2 class="title">Sucesso!</h2>
          <h3>Em breve processaremos seu pagamento e renovaremos sua assinatura.</h3>
        </div>
      </div>
    </transition>

  </div>

</template>

<script>

import { apiORDSapp } from '../shared/api-functions'
import { SysVars } from '../main'

export default {
  props: {
  },

  data() {
    return {
      email: '',
      id: '',
      errmessages: null,
      title: '',
      isPagamento: false,
      showNFe: true,
      showForcaVendas: true,
      selecionaApp: true,
      sucesso: false,
      appSelected: '',
      planoFV: [
        {
          app: 'FV',
          plano: 'B',
          nome: 'Básico',
          valor: 120,
          descricao: [
            '3 usuários inclusos',
            'Controle de Pedidos',
          ],
          valor_adicional: 50,
          selected: false,
        },
        {
          app: 'FV',
          plano: 'I',
          nome: 'Intermediário',
          valor: 160,
          descricao: [
            '3 usuários inclusos',
            'Controle de Pedidos',
            'Controle de Rentabilidade',
            'Controle de Limite de Crédito',
          ],
          valor_adicional: 50,
          selected: false,
        },
        {
          app: 'FV',
          plano: 'C',
          nome: 'Completo',
          valor: 230,
          descricao: [
            '3 usuários inclusos',
            'Controle de Pedidos',
            'Controle de Rentabilidade',
            'Controle de Limite de Crédito',
            'Emissão de NF-e',
            'Emissão de Boletos',
          ],
          valor_adicional: 50,
          selected: false,
        },
      ],

      planoLoja: [
        {
          app: 'LOJA',
          plano: 'B',
          nome: 'Básico',
          valor: 130.00,
          descricao: [
            'Catalogo de Produtos',
            'Tabela de promoções',
            'Gestão dos pedidos recebidos',
            'Recebimentos com cartão de crédito',
          ],
          // valor_adicional: 50,
          selected: false,
        },
      ],

      planoNFe: [
        {
          app: 'NFE',
          plano: 'B',
          nome: 'Básico',
          valor: 39.90,
          descricao: [
            '1 Usuário',
            'Emissão de NF-e de Produtos',
            'Emissão de NFC-e de Consumidor',
          ],
          valor_adicional: 39.90,
          selected: false,
        },
        {
          app: 'NFE',
          plano: 'I',
          nome: 'Intermediário',
          valor: 79.90,
          descricao: [
            '1 Usuário',
            'Regras de Impostos',
            'Emissão de NF-e de Produtos',
            'Emissão de NFC-e de Consumidor',
            'Emissão de SAT',
          ],
          valor_adicional: 50,
          selected: false,
        },
        {
          app: 'NFE',
          plano: 'C',
          nome: 'Completo',
          valor: 119.9,
          descricao: [
            '1 Usuário',
            'Controle de Pedidos',
            'Emissão de NF-e de Produtos',
            'Emissão de NFC-e de Consumidor',
            'Emissão de SAT',
            'Emissão de NF-e de importação',
          ],
          valor_adicional: 50,
          selected: false,
        },
      ],

      planoVarejo: [
        {
          app: 'VAREJO',
          plano: 'B',
          nome: 'Básico',
          valor: 190.00,
          descricao: [
            '3 Usuários Inclusos',
            'PDV on-line',
            'Tabela de Preços',
            'Tabela de Descontos',
            'Políticas Comerciais',
            'Emissão de SAT e NFc-e',
            'Fechamentos',
          ],
          valor_adicional: 50,
          selected: false,
        },
        {
          app: 'VAREJO',
          plano: 'I',
          nome: 'Intermediário',
          valor: 190.00,
          descricao: [
            '3 Usuários Inclusos',
            'PDV on-line',
            'Tabela de Preços',
            'Tabela de Descontos',
            'Políticas Comerciais',
            'Emissão de SAT e NFc-e',
            'Fechamentos',
          ],
          valor_adicional: 50,
          selected: false,
        },
        {
          app: 'VAREJO',
          plano: 'C',
          nome: 'Completo',
          valor: 190.00,
          descricao: [
            '3 Usuários Inclusos',
            'PDV on-line',
            'Tabela de Preços',
            'Tabela de Descontos',
            'Políticas Comerciais',
            'Emissão de SAT e NFc-e',
            'Fechamentos',
          ],
          valor_adicional: 50,
          selected: false,
        },
      ],

      recursos_concorrente: [
      ],

      recursos_fv: [
        { text: 'Importação de dados de clientes e produtos', plano1: true, plano2: true, plano3: true },
        { text: 'Integração com qualquer ERP', plano1: true, plano2: true, plano3: true },
        { text: 'Suporte ilimitado por chat, e-mail ou telefone', plano1: true, plano2: true, plano3: true },
        { text: 'Grupos de produtos', plano1: true, plano2: true, plano3: true },
        { text: 'Produtos com fotos', plano1: true, plano2: true, plano3: true },
        { text: 'Grupos de clientes', plano1: true, plano2: true, plano3: true },
        { text: 'Controle de estoque', plano1: true, plano2: true, plano3: true },
        { text: 'Cadastro de status de pedido', plano1: true, plano2: true, plano3: true },
        { text: 'Cadastro de tipos de pedido', plano1: true, plano2: true, plano3: true },
        { text: 'Cadastro de equipes de venda', plano1: true, plano2: true, plano3: true },
        { text: 'Tabelas de descontos', plano1: true, plano2: true, plano3: true },
        { text: 'Tabelas de destaques', plano1: true, plano2: true, plano3: true },
        { text: 'Tabela de preço por vendedor', plano1: true, plano2: true, plano3: true },
        { text: 'Tabela de preço por cliente', plano1: true, plano2: true, plano3: true },
        { text: 'Relatório de produtos vendidos por valor/quantidade', plano1: true, plano2: true, plano3: true },
        { text: 'Relatório de clientes', plano1: true, plano2: true, plano3: true },
        { text: 'Relatório/Indicador de evolução das vendas', plano1: true, plano2: true, plano3: true },
        { text: 'Relatório/Indicador clientes ativos, inativos', plano1: true, plano2: true, plano3: true },
        { text: 'Relatório de curva ABC de clientes', plano1: true, plano2: true, plano3: true },
        { text: 'Desconto máximo por usuário', plano1: false, plano2: true, plano3: true },
        { text: 'Agenda de atividades', plano1: false, plano2: true, plano3: true },
        { text: 'Metas de venda', plano1: false, plano2: true, plano3: true },
        { text: 'Rentabilidade do pedido', plano1: false, plano2: true, plano3: true },
        { text: 'Bloqueio de rentabilidade por usuário', plano1: false, plano2: true, plano3: true },
        { text: 'Controle de limite de crédito', plano1: false, plano2: true, plano3: true, novo: false },
        { text: 'Alerta de títulos vencidos', plano1: false, plano2: true, plano3: true },
        { text: 'Emissão de NF-e de produtos', plano1: false, plano2: false, plano3: true, novo: false },
        { text: 'CRM Oportunidades de venda', plano1: false, plano2: false, plano3: true },
      ]

    }
  },

  computed: {
    selecionados: function () {
      return this.planoFV.filter((obj) => {
        return obj.selected
      })
    },

    isEndTrial: function () {
      return SysVars.appEndTrial
    },

    isBlocked: function () {
      return SysVars.appBlocked
    },

  },


  methods: {

    handleTestar(app, plano) {
      this.$router.push('registro/' + app + '/' + plano)
    },

    handleLogin() {
      this.$router.push('/login')
    },

    handleSelecionaApp(id) {
      this.appSelected = id
      this.$nextTick(function () {
        let elmnt = document.getElementById(id)
        elmnt.scrollIntoView({ behavior: 'smooth', block: 'start' }) //POSICIONA NO ELEMENTO
      })
    },

    async apiPost() {

      // this.$appLoading(true)
      // var params = '?email=' + this.email + '&id=' + this.id
      // const ativacao = await apiORDSapp(this, 'assinatura/ativar' + params, 'get', null)
      // this.$appLoading(false)
      // if (ativacao.errmessages) {
      //   this.errmessages = login.errmessages
      //   return
      // } else {
      //   this.title = 'Sua conta foi ativada. Você será redirecionado à tela de login.'
      //   this.showLogin = true
      // }

    },

    async handleAssinar(app, plano) {

      this.$appLoading(true)
      let sendData = { codplan: plano, app: app }
      const pagseguro = await apiORDSapp(this, 'sessao/pagseguro/', 'post', sendData)
      this.$appLoading(false)

      let self = this
      window.open(pagseguro.link, "_blank");
      self.$appLoading(false)
      var resultOptions = {};
      resultOptions.updateDataTable = false;
      self.selecionaApp = false
      self.sucesso = true

      // window.PagSeguroLightbox({
      //         code: pagseguro.code
      //     },
      //     {
      //         success: function (transactionCode) {
      //             //ATUALIZA O CODIGO DA TRANSACAO NO CODIGO DE AUTENTICACAO (TABELA PAG)
      //             self.$appLoading(true)
      //             const tr = apiORDSapp(self, 'sessao/pagseguro/' + pagseguro.code + '/trcode/' + transactionCode, 'post', null)
      //             self.$appLoading(false)
      //             var resultOptions = {};
      //             resultOptions.updateDataTable = false;
      //             self.selecionaApp = false
      //             self.sucesso = true
      //             // $uibModalInstance.close(resultOptions);
      //         },
      //         abort: function () {
      //             self.$erpToastError('O processo de pagamento foi cancelado, sua assinatura não será renovada.');
      //             var resultOptions = {};
      //             resultOptions.updateDataTable = false;
      //             // $uibModalInstance.close(resultOptions);
      //         }
      //     })
    }


  },

  components: {

  },

  mounted() {
    if (this.isEndTrial && !SysVars.appNFe)
      this.showNFe = false

    if (this.isEndTrial && !SysVars.appForcaVendas)
      this.showForcaVendas = false
    console.log(this.isBlocked)
    console.log(this.isEndTrial)
    this.isPagamento = this.isEndTrial || this.isBlocked
    if (this.$route.name == 'assinar') {
      this.isPagamento = true
    }
  },

  created() {

  }

}

</script>

<style>
.shared-header {
  display: block;
  padding: 15px 0;
  margin-top: 15px;
}

.shared-header .valign {
  line-height: 30px;
  vertical-align: middle;
}

.activation {
  margin-top: 64px;
}

.activation h3 {
  margin-bottom: 32px;
  font-size: 30.4px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.58;
  letter-spacing: -.5px;
  color: #222;
  margin-top: 64px;
}

.activation h5 {
  margin-top: 30px;
  margin-bottom: 64px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.58;
  letter-spacing: -.5px;
  color: #222;
}

.activation-button {
  border: 2px solid #267da5 !important;
  /* border-radius: 3px!important; */
  border-radius: 0.70rem;
  margin-top: 50px;
  cursor: pointer;
  width: 200px !important;
  height: 45px !important;
  background-color: #267da5 !important;
  color: #fff !important;
  font-size: 15px !important;
}

.registro {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  /* display: table; */
  display: block;
  transition: opacity .3s ease;
  overflow: auto;
}

.app-button {
  border: 2px solid #ffe871 !important;
  border-radius: 0.70rem;
  cursor: pointer;
  height: 45px !important;
  background-color: #ffe871 !important;
  color: black !important;
  font-size: 16px !important;
  font-weight: 600;
}

.app {
  margin: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #d3d2d2;
  padding: 15px;
  font-size: 22px;
  letter-spacing: -0.15px;
  line-height: 24px;
  transition: all .2s;
  box-shadow: 0 5px 15px 0 rgba(82, 95, 127, .15);
}

.app:hover {
  border: 1px solid #22f387;
  cursor: pointer;
}

.active {
  border: 3px solid #22f387;
}

.app .title {
  color: #222;
  font-size: 22px;
  letter-spacing: -0.15px;
  line-height: 27px;
  display: flex;
  flex: 1;
  transition: all .2s;
  margin: 0;
  text-align: center;
}

.app .margin {
  margin-bottom: 32px;
}

.app .info {
  margin: 30px 0 50px;
}

.app .price-info {
  margin: 30px 0 50px;
}

.app p {
  color: #757575;
  font-family: Open Sans, sans-serif;
  font-size: 16px;
  line-height: 19px;
  flex: 1;
}


.price {
  color: #1cc925;
  font-size: 36px;
  font-weight: 700;
  line-height: normal;
}

.title-price {
  display: inline-block;
  font-size: 18px;
  color: #151414;
  text-align: center;
  font-weight: 600;
}

.app-info h5 {
  margin: 10px 0 20px;
  font-weight: 300;
  line-height: 1.58;
  letter-spacing: -.5px;
  color: #222;
}

.title {
  color: #222;
  font-size: 36px;
  font-weight: 600;
  letter-spacing: -1.13px;
  line-height: 44px;
  margin: 90px 0 0;
}

.box-clientes {
  margin: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* border: 1px solid #E0E0E0; */
  /* border-radius: 15px; */
  padding: 15px;
  transition: all .2s;
  box-shadow: 0 5px 15px 0 #3a405048
}






.recursos-container {
  margin-top: 10px;
  transition: all .2s;
  box-shadow: 0 5px 15px 0 #3a405048;
  border: 1px solid #d3d2d2;
  /* border-radius: 15px; */
}

.recursos-container th {
  padding: 20px 30px 5px;
}

.recursos-container td {
  padding: 20px 30px;
  border: 1px solid #f4f5f7;
}

.recursos-container table thead {
  /* background-color: #fafbfc; */
}

.recursos-container .feature-check {
  width: 215px;
}

.recursos-container .title {
  color: #222;
  font-size: 18px;
  font-weight: 400;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/forms/app-assinatura-form.vue